import { render, staticRenderFns } from "./OutsourceRules.vue?vue&type=template&id=ce040de2&scoped=true&"
import script from "./OutsourceRules.vue?vue&type=script&lang=ts&"
export * from "./OutsourceRules.vue?vue&type=script&lang=ts&"
import style0 from "./OutsourceRules.vue?vue&type=style&index=0&id=ce040de2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce040de2",
  null
  
)

export default component.exports